package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.ActiveLockpicking
import fr.manyverse.app.domain.model.EventContent
import fr.manyverse.app.domain.model.EventType
import fr.manyverse.app.domain.repository.GameEventRepository
import fr.manyverse.app.domain.repository.LockpickingRepository
import fr.manyverse.app.domain.validation.LockpickingValidator

/**
 * Use case for creating a lockpicking challenge.
 * Validates inputs, creates the challenge, and logs a LOCKPICKING_LAUNCHED event.
 */
class CreateLockpickingUseCase(
    private val lockpickingRepository: LockpickingRepository,
    private val gameEventRepository: GameEventRepository
) {
    suspend operator fun invoke(
        tableId: String,
        targetParticipantId: String,
        lockCount: Int,
        timeLimitSeconds: Int?,
        showLockCount: Boolean,
        soundEnabled: Boolean,
        createdBy: String
    ): Result<ActiveLockpicking> {
        LockpickingValidator.validateForCreation(
            targetParticipantId = targetParticipantId,
            lockCount = lockCount,
            timeLimitSeconds = timeLimitSeconds
        ).onFailure {
            return Result.failure(it)
        }

        val result = lockpickingRepository.createLockpicking(
            tableId = tableId,
            targetParticipantId = targetParticipantId,
            lockCount = lockCount,
            timeLimitSeconds = timeLimitSeconds,
            showLockCount = showLockCount,
            soundEnabled = soundEnabled,
            createdBy = createdBy
        )

        result.onFailure {
            return Result.failure(it)
        }

        val lockpicking = result.getOrThrow()

        val content = EventContent.LockpickingLaunched(
            lockpickingId = lockpicking.id,
            lockCount = lockCount
        )

        gameEventRepository.createEvent(
            tableId = tableId,
            type = EventType.LOCKPICKING_LAUNCHED,
            triggeredBy = createdBy,
            targetParticipants = listOf(targetParticipantId),
            content = content
        )

        return Result.success(lockpicking)
    }
}
